/**
 * webview.js
 * This file including all native web methods. You can use in your project.
 * This file main goal make generic all methods and be saved your time with non duplicated codes.
 *
 * @version 1.1.3
 * @author Ozan Gelmez <ozan.gelmez@vodafone.com>
 * @updated 2023-05-18
 */

if (typeof window !== "undefined") {
  window.clientVariables = {};
  window.clientEventData = {};
}
const vfWebView = {
  onBack: () => {
    var _window,
      _window$Android,
      _window2,
      _window2$webkit,
      _window2$webkit$messa;
    let isCalled = false;
    if (
      (_window = window) !== null &&
      _window !== void 0 &&
      (_window$Android = _window.Android) !== null &&
      _window$Android !== void 0 &&
      _window$Android.onBack
    ) {
      window.Android.onBack();
      isCalled = true;
    }
    if (
      (_window2 = window) !== null &&
      _window2 !== void 0 &&
      (_window2$webkit = _window2.webkit) !== null &&
      _window2$webkit !== void 0 &&
      (_window2$webkit$messa = _window2$webkit.messageHandlers) !== null &&
      _window2$webkit$messa !== void 0 &&
      _window2$webkit$messa.onBack
    ) {
      window.webkit.messageHandlers.onBack.postMessage("");
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with onBack callback.Check webView function."
      );
  },
  sessionTimeOut: () => {
    var _window3,
      _window3$Android,
      _window4,
      _window4$webkit,
      _window4$webkit$messa;
    let isCalled = false;
    if (
      (_window3 = window) !== null &&
      _window3 !== void 0 &&
      (_window3$Android = _window3.Android) !== null &&
      _window3$Android !== void 0 &&
      _window3$Android.sessionTimeOut
    ) {
      window.Android.sessionTimeOut();
      isCalled = true;
    }
    if (
      (_window4 = window) !== null &&
      _window4 !== void 0 &&
      (_window4$webkit = _window4.webkit) !== null &&
      _window4$webkit !== void 0 &&
      (_window4$webkit$messa = _window4$webkit.messageHandlers) !== null &&
      _window4$webkit$messa !== void 0 &&
      _window4$webkit$messa.sessionTimeOut
    ) {
      window.webkit.messageHandlers.sessionTimeOut.postMessage("");
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with sessionTimeOut callback.Check webView function."
      );
  },
  /**
   * @returns - (Doesnt return) //android only
   */
  clearHistory: () => {
    var _window5, _window5$Android;
    let isCalled = false;
    if (
      (_window5 = window) !== null &&
      _window5 !== void 0 &&
      (_window5$Android = _window5.Android) !== null &&
      _window5$Android !== void 0 &&
      _window5$Android.clearHistory
    ) {
      window.Android.clearHistory();
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with clearHistory callback.Check webView function."
      );
  },
  /**
   * @param {string} text
   * @returns - (Doesnt return) //android only
   */
  copyToClipboard: (text) => {
    var _window6, _window6$Android;
    let isCalled = false;
    if (
      (_window6 = window) !== null &&
      _window6 !== void 0 &&
      (_window6$Android = _window6.Android) !== null &&
      _window6$Android !== void 0 &&
      _window6$Android.copyToClipboard
    ) {
      window.Android.copyToClipboard(text);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with copyToClipboard callback.Check webView function."
      );
  },
  /**
   * @param {string} url
   */
  openBrowser: (url) => {
    var _window7,
      _window7$Android,
      _window8,
      _window8$webkit,
      _window8$webkit$messa;
    let isCalled = false;
    if (
      (_window7 = window) !== null &&
      _window7 !== void 0 &&
      (_window7$Android = _window7.Android) !== null &&
      _window7$Android !== void 0 &&
      _window7$Android.openBrowser
    ) {
      window.Android.openBrowser(url);
      isCalled = true;
    }
    if (
      (_window8 = window) !== null &&
      _window8 !== void 0 &&
      (_window8$webkit = _window8.webkit) !== null &&
      _window8$webkit !== void 0 &&
      (_window8$webkit$messa = _window8$webkit.messageHandlers) !== null &&
      _window8$webkit$messa !== void 0 &&
      _window8$webkit$messa.openBrowser
    ) {
      window.webkit.messageHandlers.openBrowser.postMessage(url);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with openBrowser callback.Check webView function."
      );
  },
  /**
   * @param {string} vfDeeplink
   */
  openVfDeeplink: (vfDeeplink) => {
    var _window9,
      _window9$Android,
      _window10,
      _window10$webkit,
      _window10$webkit$mess;
    let isCalled = false;
    if (
      (_window9 = window) !== null &&
      _window9 !== void 0 &&
      (_window9$Android = _window9.Android) !== null &&
      _window9$Android !== void 0 &&
      _window9$Android.openVfDeeplink
    ) {
      window.Android.openVfDeeplink(vfDeeplink);
      isCalled = true;
    }
    if (
      (_window10 = window) !== null &&
      _window10 !== void 0 &&
      (_window10$webkit = _window10.webkit) !== null &&
      _window10$webkit !== void 0 &&
      (_window10$webkit$mess = _window10$webkit.messageHandlers) !== null &&
      _window10$webkit$mess !== void 0 &&
      _window10$webkit$mess.openVfDeeplink
    ) {
      window.webkit.messageHandlers.openVfDeeplink.postMessage(vfDeeplink);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with openVfDeeplink callback.Check webView function."
      );
  },
  /**
   * If you want to get data. You can call with window.clientVariables and then you can use everywhere.
   */

  getAllClientData: () => {
    var _window11,
      _window11$Android,
      _window12,
      _window12$webkit,
      _window12$webkit$mess;
    let isCalled = false;
    let data = {};
    if (
      (_window11 = window) !== null &&
      _window11 !== void 0 &&
      (_window11$Android = _window11.Android) !== null &&
      _window11$Android !== void 0 &&
      _window11$Android.getAllData
    ) {
      data = window.Android.getAllData();
      getAllData(data);
      isCalled = true;
    }
    if (
      (_window12 = window) !== null &&
      _window12 !== void 0 &&
      (_window12$webkit = _window12.webkit) !== null &&
      _window12$webkit !== void 0 &&
      (_window12$webkit$mess = _window12$webkit.messageHandlers) !== null &&
      _window12$webkit$mess !== void 0 &&
      _window12$webkit$mess.getAllData
    ) {
      window.webkit.messageHandlers.getAllData.postMessage({});
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with getAllClientData callback.Check webView function."
      );
  },
  /**
   * @param {string} deeplink
   */
  share: (deeplink) => {
    var _window13,
      _window13$Android,
      _window14,
      _window14$webkit,
      _window14$webkit$mess;
    let isCalled = false;
    if (
      (_window13 = window) !== null &&
      _window13 !== void 0 &&
      (_window13$Android = _window13.Android) !== null &&
      _window13$Android !== void 0 &&
      _window13$Android.share
    ) {
      window.Android.share(deeplink);
      isCalled = true;
    }
    if (
      (_window14 = window) !== null &&
      _window14 !== void 0 &&
      (_window14$webkit = _window14.webkit) !== null &&
      _window14$webkit !== void 0 &&
      (_window14$webkit$mess = _window14$webkit.messageHandlers) !== null &&
      _window14$webkit$mess !== void 0 &&
      _window14$webkit$mess.share
    ) {
      window.webkit.messageHandlers.share.postMessage(deeplink);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with share callback.Check webView function."
      );
  },
  /**
  * @param {string} base64
  */
    openPdf: base64 => {
      var _window15, _window15$Android, _window16, _window16$webkit, _window16$webkit$mess;
      let isCalled = false;
      if ((_window15 = window) !== null && _window15 !== void 0 && (_window15$Android = _window15.Android) !== null && _window15$Android !== void 0 && _window15$Android.openPdf) {
        window.Android.openPdf(base64);
        isCalled = true;
      }
      if ((_window16 = window) !== null && _window16 !== void 0 && (_window16$webkit = _window16.webkit) !== null && _window16$webkit !== void 0 && (_window16$webkit$mess = _window16$webkit.messageHandlers) !== null && _window16$webkit$mess !== void 0 && _window16$webkit$mess.openPdf) {
        window.webkit.messageHandlers.openPdf.postMessage(base64);
        isCalled = true;
      }
      if (!isCalled) console.log("Something wrong with share callback.Check webView function.");
    },
  /**
   * @param {boolean} loaderVisibility
   */
  manageLoading: (loaderVisibility) => {
    var _window15,
      _window15$Android,
      _window16,
      _window16$webkit,
      _window16$webkit$mess;
    let isCalled = false;
    if (
      (_window15 = window) !== null &&
      _window15 !== void 0 &&
      (_window15$Android = _window15.Android) !== null &&
      _window15$Android !== void 0 &&
      _window15$Android.manageLoading
    ) {
      window.Android.manageLoading(loaderVisibility);
      isCalled = true;
    }
    if (
      (_window16 = window) !== null &&
      _window16 !== void 0 &&
      (_window16$webkit = _window16.webkit) !== null &&
      _window16$webkit !== void 0 &&
      (_window16$webkit$mess = _window16$webkit.messageHandlers) !== null &&
      _window16$webkit$mess !== void 0 &&
      _window16$webkit$mess.manageLoading
    ) {
      window.webkit.messageHandlers.manageLoading.postMessage(loaderVisibility);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with manageLoading callback.Check webView function."
      );
  },
  /**
   * @param {object} content
   * content examle {url : "imageUrl", title : "title"}
   */
  shareImage: (content) => {
    var _window17,
      _window17$Android,
      _window18,
      _window18$webkit,
      _window18$webkit$mess;
    const { url, title } = content;
    let isCalled = false;
    if (
      (_window17 = window) !== null &&
      _window17 !== void 0 &&
      (_window17$Android = _window17.Android) !== null &&
      _window17$Android !== void 0 &&
      _window17$Android.shareImage
    ) {
      window.Android.shareImage(url, title);
      isCalled = true;
    }
    if (
      (_window18 = window) !== null &&
      _window18 !== void 0 &&
      (_window18$webkit = _window18.webkit) !== null &&
      _window18$webkit !== void 0 &&
      (_window18$webkit$mess = _window18$webkit.messageHandlers) !== null &&
      _window18$webkit$mess !== void 0 &&
      _window18$webkit$mess.shareImage
    ) {
      window.webkit.messageHandlers.shareImage.postMessage(content);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with shareImage callback.Check webView function."
      );
  },
  /**
   * This method for if you want to work with different method you can use
   * For example, You would make change to toolbar color when open the product detail.
   * Then frontend side call to your "event" method with json string type
   * example; jsonObj = "{"command":"changeToolbarColor","colorHex":"#1111111",}" Android.event(jsonObj)
   * then you can observe this action
   * If you want to get event data. You can call with window.clientEventData and then you can use everywhere.
   * @param {{color: string, isLight: string, command: string}} response
   */
  eventClient: (response) => {
    var _window19,
      _window19$Android,
      _window20,
      _window20$webkit,
      _window20$webkit$mess;
    let isCalled = false;
    let eventData;
    if (
      (_window19 = window) !== null &&
      _window19 !== void 0 &&
      (_window19$Android = _window19.Android) !== null &&
      _window19$Android !== void 0 &&
      _window19$Android.event
    ) {
      eventData = window.Android.event(JSON.stringify(response));
      event(eventData);
      isCalled = true;
    }
    if (
      (_window20 = window) !== null &&
      _window20 !== void 0 &&
      (_window20$webkit = _window20.webkit) !== null &&
      _window20$webkit !== void 0 &&
      (_window20$webkit$mess = _window20$webkit.messageHandlers) !== null &&
      _window20$webkit$mess !== void 0 &&
      _window20$webkit$mess.event
    ) {
      window.webkit.messageHandlers.event.postMessage(response);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with eventClient callback.Check webView function."
      );
  },
  /**
   * @param {string} intent
   * @param {string} data
   */
  tealiumJSBridge: (intent, data) => {
    var _window21,
      _window21$Android,
      _window22,
      _window22$webkit,
      _window22$webkit$mess;
    let isCalled = false;
    if (
      (_window21 = window) !== null &&
      _window21 !== void 0 &&
      (_window21$Android = _window21.Android) !== null &&
      _window21$Android !== void 0 &&
      _window21$Android.tealiumJSBridge
    ) {
      window.Android.tealiumJSBridge(intent, data);
      isCalled = true;
    }
    if (
      (_window22 = window) !== null &&
      _window22 !== void 0 &&
      (_window22$webkit = _window22.webkit) !== null &&
      _window22$webkit !== void 0 &&
      (_window22$webkit$mess = _window22$webkit.messageHandlers) !== null &&
      _window22$webkit$mess !== void 0 &&
      _window22$webkit$mess.tealiumJSBridge
    ) {
      window.webkit.messageHandlers.tealiumJSBridge.postMessage(intent, data);
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with tealiumJSBridge callback.Check webView function."
      );
  },
  trackEvent: () => {
    var _window23,
      _window23$Android,
      _window24,
      _window24$webkit,
      _window24$webkit$mess;
    let isCalled = false;
    if (
      (_window23 = window) !== null &&
      _window23 !== void 0 &&
      (_window23$Android = _window23.Android) !== null &&
      _window23$Android !== void 0 &&
      _window23$Android.trackEvent
    ) {
      window.Android.trackEvent();
      isCalled = true;
    }
    if (
      (_window24 = window) !== null &&
      _window24 !== void 0 &&
      (_window24$webkit = _window24.webkit) !== null &&
      _window24$webkit !== void 0 &&
      (_window24$webkit$mess = _window24$webkit.messageHandlers) !== null &&
      _window24$webkit$mess !== void 0 &&
      _window24$webkit$mess.trackEvent
    ) {
      window.webkit.messageHandlers.trackEvent.postMessage("");
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with trackEvent callback.Check webView function."
      );
  },
  addTemporary: () => {
    var _window25,
      _window25$Android,
      _window26,
      _window26$webkit,
      _window26$webkit$mess;
    let isCalled = false;
    if (
      (_window25 = window) !== null &&
      _window25 !== void 0 &&
      (_window25$Android = _window25.Android) !== null &&
      _window25$Android !== void 0 &&
      _window25$Android.addTemporary
    ) {
      window.Android.addTemporary();
      isCalled = true;
    }
    if (
      (_window26 = window) !== null &&
      _window26 !== void 0 &&
      (_window26$webkit = _window26.webkit) !== null &&
      _window26$webkit !== void 0 &&
      (_window26$webkit$mess = _window26$webkit.messageHandlers) !== null &&
      _window26$webkit$mess !== void 0 &&
      _window26$webkit$mess.addTemporary
    ) {
      window.webkit.messageHandlers.addTemporary.postMessage("");
      isCalled = true;
    }
    if (!isCalled)
      console.log(
        "Something wrong with addTemporary callback.Check webView function."
      );
  }
};
function getAllData(variables) {
  window.clientVariables =
    "object" == typeof variables
      ? variables
      : "string" == typeof variables
      ? JSON.parse(variables)
      : variables;
}
function event(eventValues) {
  const variablesObj = eventValues ? JSON.parse(eventValues) : false;
  window.clientEventData = variablesObj;
}
if (typeof window !== "undefined") {
  window.vfWebview = vfWebView;
  window.getAllData = getAllData;
  window.event = event;
}
module.exports = vfWebView;
